'use client'

import { useEffect, useContext, useState } from 'react'
import { RootContext } from '@/modules/contextService'
import { RootProps } from '@/app/layout'
import ThemeClient from '@/app/v1/ThemeClient'
import PublisherHeader from '@/components/display/PublisherHeader'
import styles from '@/app/self/styles.module.scss'
import cookieService from '@/modules/cookieService'
import MainFooter from '@/components/MainFooter'

function SelfLayout ({ children }: RootProps) {
  const { rootData } = useContext(RootContext)
  const { user } = rootData
  const [selectedTheme, setSelectedTheme] = useState('')

  useEffect(() => {
    const storedTheme = cookieService.getCookie('theme')
    setSelectedTheme(storedTheme || 'dark')
  }, [])

  return (
    <section>
      <style>{'body,html { background-color: var(--background-color); color: var(--primary-font-rgb); }'}</style>
      <ThemeClient theme={selectedTheme}>
        <div className={styles.main}>
          <PublisherHeader
            user={user}
            size={'large'}
          />
          <div className={styles.content}>
            {children}
          </div>
          <MainFooter />
        </div>
      </ThemeClient>
    </section>
  )
}

export default SelfLayout
